import React, { useMemo } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box } from "@mui/material";
import { Iconify } from "../../../Minimal/src/components/iconify/iconify";
import ViewCartTableRowEposSales from "./ViewCartTableRowEposSales";
import CartTableRowSkeleton from "../../Epos/component/CartTableRowSkeleton";
import { applyShowPromoLabelDedupe } from "../../Epos/utils/cartCalculations";
import commonStyles from "../../../common/commonStyles.css";

const ViewCartTableEposSales = ({
  cartItems,
  showVatAsAmount = false,
  isLoading = false,
  getItemDetails = null,
  isItemPending = null,
  isTelecaller = false,
  bundleDiscounts = [],
}) => {
  const renderedRows = useMemo(() => {
    const rows = applyShowPromoLabelDedupe(Array.isArray(cartItems) ? cartItems : [], bundleDiscounts);
    return rows.map((item, index) => {
      const itemDetails = getItemDetails ? getItemDetails(item) : null;
      const isPending = isItemPending ? isItemPending(item.product_id, item.id) : false;
      const orderType = item.order_type || item.type || "Box";
      const stableKey = item.product_id 
        ? `${item.product_id}_${orderType}` 
        : `${item.id || index}_${orderType}`;
      
      return (
        <ViewCartTableRowEposSales
          key={stableKey}
          item={item}
          index={index}
          showVatAsAmount={showVatAsAmount}
          isLoading={isPending}
          itemDetails={itemDetails}
          isTelecaller={isTelecaller}
          bundleDiscounts={bundleDiscounts}
          cartItems={rows}
        />
      );
    });
  }, [cartItems, getItemDetails, isItemPending, showVatAsAmount, isTelecaller, bundleDiscounts]
  );

  return (
    <TableContainer 
      component={Box} 
      sx={{ 
        mt: 1, 
        mx: { xs: -2, sm: -2, md: -2 }, 
        width: { xs: 'calc(100% + 32px)', sm: 'calc(100% + 32px)', md: 'calc(100% + 32px)' },
        borderRadius: 0, 
        height: 'calc(100vh - 235px)', 
        overflowX: 'auto',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          height: '8px',
          width: '8px'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f1f1f1'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '4px'
        }
      }}
    >
      <Table 
        size="small"
        className="table-cell-border"
        sx={{ 
          tableLayout: 'fixed',
          width: '100%'
        }}
      >
        <TableHead>
          <TableRow className="table-cell-header">
            <TableCell sx={{ width: '30px', textAlign: 'center', }}>No</TableCell>
            <TableCell sx={{ width: '70px', padding: "4px" }}>Code</TableCell>
            <TableCell sx={{ width: '40px', padding: "4px" }}>Type</TableCell>
            <TableCell sx={{ width: '160px', padding: "4px" }}>Product Description</TableCell>
            <TableCell sx={{ width: '60px', textAlign: 'center' }}>Allot Qty</TableCell>
            {isTelecaller ? (
              <>
                <TableCell sx={{ width: '60px', textAlign: 'right', padding: "4px" }}>Std. Price</TableCell>
                <TableCell sx={{ width: '60px', textAlign: 'right', padding: "4px" }}>Offer Price</TableCell>
              </>
            ) : (
              <TableCell sx={{ width: '60px', textAlign: 'right', padding: "4px" }}>Unit Price</TableCell>
            )}
            <TableCell sx={{ width: '40px', textAlign: 'right',padding: "4px" }}>VAT</TableCell>
            <TableCell sx={{ width: '50px', textAlign: 'right', padding: "4px" }}>Total</TableCell>
            <TableCell sx={{ width: '40px', textAlign: 'center', padding: "4px" }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading && cartItems.length === 0 ? (
            Array.from({ length: 3 }).map((_, index) => (
              <CartTableRowSkeleton key={index} />
            ))
          ) : cartItems.length === 0 ? (
            <TableRow>
              <TableCell colSpan={isTelecaller ? 10 : 9} align="center" sx={{ py: 3, border: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Iconify 
                    icon="solar:cart-large-bold" 
                    width={80} 
                    sx={{ color: 'text.disabled', mb: 2 }} 
                  />
                  <Typography variant="h6" color="text.primary" gutterBottom>
                    No products found
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            renderedRows
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ViewCartTableEposSales;
